import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import distributionImg from "../../assets/images/Distribution-Yield.png";
import growthImg from "../../assets/images/Investment-Growth.png";
import volatilityImg from "../../assets/images/Reduced-Volatility.png";
import alignmentImg from "../../assets/images/Aligned-with-Investor-interests.png";
import redemptionImg from "../../assets/images/Share-Redemptions.png";
import diversificationImg from "../../assets/images/Portfolio-Diversification.png";

// css
import "./WhyConsiderInvesting.css";

const WhyConsiderInvesting = () => {
  const [stateSelection, setStateSelection] = useState(
    sessionStorage.getItem("stateSelection") || ""
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setStateSelection(sessionStorage.getItem("stateSelection") || "");
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // react slider settings
  const settings = {
    // dots: true,
    // infinite: true,
    // speed: 500,
    // slidesToShow: 1,
    // slidesToScroll: 1,
    // arrows: false,
    dots: true,
    className: "center",
    centerMode: true,
    infinite: false,
    centerPadding: "15px",
    speed: 500,
    slidesToShow: 1,
    // slidesToScroll: 1,
    arrows: false,
  };

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  const slider = React.useRef(null);

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  const WhyConsiderInvestingLib = [
    {
      image: distributionImg,
      title: `Monthly Distributions`,
      sup1: "5",
      sup2: "6",
      info: `One of DIR’s key objectives is to provide monthly cash distributions.`,
    },
    {
      image: growthImg,
      title: `Growth`,
      title2: `Potential`,
      mobile: `Grown Potential`,
      sup1: "5",
      sup2: "7",
      info: `We invest in sectors and markets in the path of technology megatrends where we see outsized growth potential with the objective of increasing the net asset value of investors’ shares.`,
    },
    ...(stateSelection !== "Ohio"
      ? [
          {
            image: volatilityImg,
            title: `Helps Combat Volatility`,
            sup1: "5",
            sup2: "7",
            info: `DIR’s non-traded structure means its value is more closely tied to the real estate fundamentals of the properties in the portfolio, vs. public equity market valuations.`,
          },
        ]
      : []),
    {
      image: alignmentImg,
      title: `Alignment of Interests`,
      sup1: "5",
      sup2: "8",
      info: `DIR’s advisor is compensated in part by a distribution that is tied to total annual returns, more closely aligning its interests with yours.`,
    },
    {
      image: redemptionImg,
      title: `Monthly Redemption Requests`,
      sup1: "5",
      sup2: "9",
      info: `With DIR — investors decide when to request redemption of shares (subject to certain limitations) - as there is no targeted liquidity window. Shares should be considered as having only limited liquidity and at times may be illiquid.`,
    },
    {
      image: diversificationImg,
      title: `Enhanced Diversification`,
      sup1: "5",
      sup2: "10",
      info: `DIR may help enhance portfolio diversification by providing access to a differentiated real estate sector.`,
    },
  ];

  return (
    <section className="" id="why-consider-investing">
      <div className="main-padding">
        <div className="main-margin">
          <h1 className="sub-header mb-12">Why Consider Investing</h1>
          {screenSize.dynamicWidth > 700 ? (
            // <div className="grid md:grid-cols-3 xl:grid-cols-6 gap-4">
            <div
              className={
                stateSelection === "Ohio"
                  ? "grid md:grid-cols-3 xl:grid-cols-5 gap-4"
                  : "grid md:grid-cols-3 xl:grid-cols-6 gap-4"
              }
            >
              {WhyConsiderInvestingLib.map((a, i) => {
                return (
                  <div
                    key={i}
                    className="shadow-lg p-5 flex flex-col items-center"
                  >
                    <div>
                      <img src={a.image} alt={a.title} />
                    </div>
                    {a.title2 ? (
                      <h2 className="text-center mb-4 font-semibold">
                        {a.title}
                        <br />
                        {a.title2}
                        <sup>{a.sup1}</sup>
                        <sup>,</sup>
                        <sup>{a.sup2}</sup>
                      </h2>
                    ) : (
                      <h2 className="text-center mb-4 font-semibold">
                        {a.title}
                        <sup>{a.sup1}</sup>
                        <sup>,</sup>
                        <sup>{a.sup2}</sup>
                      </h2>
                    )}
                    <p>{a.info}</p>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <Slider ref={slider} {...settings}>
                {WhyConsiderInvestingLib.map((a, i) => {
                  return (
                    <div
                      div
                      key={i}
                      className="shadow-lg p-5 flex flex-col items-center h-[21rem]"
                    >
                      <div className="flex justify-center">
                        <img src={a.image} alt={a.title} />
                      </div>
                      {a.mobile ? (
                        <h2 className="text-center mb-4 font-semibold">
                          {a.mobile}
                          <sup>{a.sup1}</sup>
                          <sup>,</sup>
                          <sup>{a.sup2}</sup>
                        </h2>
                      ) : (
                        <h2 className="text-center mb-4 font-semibold">
                          {a.title}
                          <sup>{a.sup1}</sup>
                          <sup>,</sup>
                          <sup>{a.sup2}</sup>
                        </h2>
                      )}
                      <p>{a.info}</p>
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WhyConsiderInvesting;
